var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.92297,20.13071h-3.42992v-5.52717C33.49304,6.54436,28.05922-.01237,20.00003-.01237S6.50702,6.54436,6.50702,14.60354v5.52717H3.07703c-1.69934,0-3.07703,1.37763-3.07703,3.07703v20.7276c0,1.69941,1.37769,3.07703,3.07703,3.07703H36.92297c1.69941,0,3.07703-1.37763,3.07703-3.07703V23.20774c0-1.69941-1.37763-3.07703-3.07703-3.07703ZM11.63541,14.60354c0-5.23156,3.13306-9.48752,8.36462-9.48752s8.36462,4.25596,8.36462,9.48752v5.52717H11.63541v-5.52717Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.844f8c555793b78b1237ede20dd467fc.svg";
export { ForwardRef as ReactComponent };